import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { restaurantServiceUrl } from '../../../../urls'

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
}

const restaurantInstance = axios.create({
  baseURL: restaurantServiceUrl,
  headers,
})

restaurantInstance.interceptors.request.use(config => {
  return requestInterceptor(config)
}, error => Promise.reject(error))

restaurantInstance.interceptors.response.use(response => response, error => {
  return responseInterceptor(error)
})

export default restaurantInstance
